const CANONICAL_ORIGIN = 'https://salescrunchcrm.com';

// Sets title, meta description, OG/Twitter tags, canonical link and
// optional JSON-LD for a page. Returns a cleanup fn for useEffect.
export function applySeo({ title, description, path, type = 'website', jsonLd = null }) {
  const prevTitle = document.title;
  document.title = title;
  const cleanups = [];
  const url = `${CANONICAL_ORIGIN}${path}`;
  const ogImage = `${CANONICAL_ORIGIN}/og-default.svg`;

  const upsertMeta = (attr, key, content) => {
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    let created = false;
    let prev = null;
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, key);
      document.head.appendChild(el);
      created = true;
    } else {
      prev = el.getAttribute('content');
    }
    el.setAttribute('content', content);
    return () => {
      if (created) el.remove();
      else if (prev !== null) el.setAttribute('content', prev);
    };
  };

  cleanups.push(
    upsertMeta('name', 'description', description),
    upsertMeta('property', 'og:title', title),
    upsertMeta('property', 'og:description', description),
    upsertMeta('property', 'og:url', url),
    upsertMeta('property', 'og:type', type),
    upsertMeta('property', 'og:site_name', 'SalesCrunchCRM'),
    upsertMeta('property', 'og:image', ogImage),
    upsertMeta('name', 'twitter:card', 'summary_large_image'),
    upsertMeta('name', 'twitter:title', title),
    upsertMeta('name', 'twitter:description', description),
    upsertMeta('name', 'twitter:image', ogImage),
  );

  let link = document.querySelector('link[rel="canonical"]');
  const hadLink = !!link;
  const prevHref = hadLink ? link.getAttribute('href') : null;
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', url);
  cleanups.push(() => {
    if (!hadLink) link.remove();
    else link.setAttribute('href', prevHref);
  });

  if (jsonLd) {
    const s = document.createElement('script');
    s.type = 'application/ld+json';
    s.text = JSON.stringify(jsonLd);
    document.head.appendChild(s);
    cleanups.push(() => s.remove());
  }

  return () => {
    document.title = prevTitle;
    cleanups.forEach((fn) => fn());
  };
}

export { CANONICAL_ORIGIN };
